var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{class:{
        item_has_sub_menu: _vm.hasChildren,
        active: _vm.isActive
    }},[_c('a',{on:{"click":function($event){$event.preventDefault();return _vm.onListClick.apply(null, arguments)}}},[_vm._v("\n        "+_vm._s(_vm.item.text)+"\n    ")]),_vm._v(" "),(_vm.isActive)?_c('navigation-sub-menu',{attrs:{"items":_vm.item.navigationItems}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }